// extracted by mini-css-extract-plugin
module.exports = {"base":"LogoMarquee_base___G_2e","container":"LogoMarquee_container__OrQWT","containerWithSquash":"LogoMarquee_containerWithSquash__M0nnI"};